import { render, staticRenderFns } from "./ClientRequestSavedPrices.vue?vue&type=template&id=49b6f9b4&scoped=true"
import script from "./ClientRequestSavedPrices.vue?vue&type=script&lang=js"
export * from "./ClientRequestSavedPrices.vue?vue&type=script&lang=js"
import style0 from "./ClientRequestSavedPrices.vue?vue&type=style&index=0&id=49b6f9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b6f9b4",
  null
  
)

export default component.exports